// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Container, Card, Table, Button, Spinner, Alert
// } from "react-bootstrap";
// import { URL } from "../../../config";
// import "./ServitorReferral.css";

// export default function ServitorReferralDetails() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const token = localStorage.getItem("adminToken");

//   const [details, setDetails] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchDetails = async () => {
//       setLoading(true);
//       try {
//         const { data } = await axios.get(`${URL}/admin/servitor-referral/${id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setDetails(data?.transactions || []);
//         setSummary(data?.summary || null);
//       } catch (err) {
//         console.error("Error fetching details:", err);
//         setError("Failed to load referral details.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDetails();
//   }, [id, token]);

//   if (loading) return (
//     <div className="text-center mt-4">
//       <Spinner animation="border" />
//       <p>Loading referral details...</p>
//     </div>
//   );

//   if (error) return <Alert variant="danger">{error}</Alert>;

//   return (
//     <Container fluid className="servitorreferral-container">
//       <Card className="servitorreferral-card">
//         <Card.Body>
//           <Card.Header className="servitorreferral-header">
//             <h4 className="servitorreferral-title">Referral Details for Servitor #{id}</h4>
//           </Card.Header>

//           {summary && (
//             <div className="mb-3">
//               <strong>Name:</strong> {summary.name} <br />
//               <strong>Mobile:</strong> {summary.mobile} <br />
//               <strong>Referral Code:</strong> {summary.referralCode} <br />
//               <strong>Invited:</strong> {summary.invitedCount} <br />
//               <strong>Qualified:</strong> {summary.qualifiedCount} <br />
//               <strong>Total Earned:</strong> ৳{summary.totalEarned.toLocaleString()}
//             </div>
//           )}

//           <Table striped bordered hover responsive className="servitorreferral-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Invited Servitor</th>
//                  <th>Invited Servitor ID</th>
//                  <th>Mobile</th>              
//                 <th>Bonus Amount</th>
//                 <th>Feedback</th>
//                 <th>Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {details.length > 0 ? (
//                 details.map((tx, i) => (
//                   <tr key={tx.Id}>
//                     <td>{i + 1}</td>
//                     <td>{tx.peer?.fullName || "Unknown"}</td>
//                     <td>{tx.peer?.id ?? "—"}</td>          
//                     <td>{tx.peer?.mobile ?? "—"}</td>     
//                     {/* <td>৳{tx.netAmount}</td> */}
//                     <td>৳{Number(tx.servitorBonus ?? 0).toLocaleString()}</td>
//                     <td>{tx.feedback || "-"}</td>
//                     <td>{new Date(tx.transactionDate).toLocaleString()}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" className="text-center">No referral transactions found.</td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>

//           <Button variant="secondary" onClick={() => navigate(-1)}>Back</Button>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }







// import React, { useEffect, useState, useMemo } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Container, Card, Table, Button, Spinner, Alert, Row, Col, Badge
// } from "react-bootstrap";
// import {
//   FiUser, FiPhone, FiCode, FiUsers, FiCheckCircle, FiDollarSign, FiArrowLeft
// } from "react-icons/fi";
// import { URL } from "../../../config";
// import "./ServitorReferral.css";

// export default function ServitorReferralDetails() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const token = localStorage.getItem("adminToken");

//   const [details, setDetails] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // helpers
//   const formatBDT = (n) => `৳${Number(n || 0).toLocaleString()}`;
//   const initialsOf = (fullName = "") =>
//     fullName.trim().split(/\s+/).slice(0, 2).map(s => s[0]?.toUpperCase() || "").join("") || "NA";

//   useEffect(() => {
//     const fetchDetails = async () => {
//       setLoading(true);
//       try {
//         const { data } = await axios.get(`${URL}/admin/servitor-referral/${id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setDetails(Array.isArray(data?.transactions) ? data.transactions : []);
//         setSummary(data?.summary || null);
//         setError("");
//       } catch (err) {
//         console.error("Error fetching details:", err);
//         setError("Failed to load referral details.");
//         setDetails([]);
//         setSummary(null);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchDetails();
//   }, [id, token]);

//   const totalEarned = useMemo(() => summary?.totalEarned ?? 0, [summary]);

//   if (loading) {
//     return (
//       <div className="text-center mt-4">
//         <Spinner animation="border" />
//         <p>Loading referral details...</p>
//       </div>
//     );
//   }

//   if (error) return <Alert variant="danger" className="mx-3">{error}</Alert>;

//   return (
//     <Container fluid className="servitorreferral-container">
//       {/* Topbar with Back */}
//       <div className="srd-topbar">
//         <div className="srd-topbar-left">
//           <Button
//             variant="link"
//             className="srd-back-btn-top"
//             onClick={() => navigate(-1)}
//             aria-label="Go back"
//           >
//             <FiArrowLeft className="me-2" />
//             Back
//           </Button>
//         </div>
//         <div className="srd-topbar-right">{/* space for future actions */}</div>
//       </div>

//       {/* Page Title */}
//       <div className="srd-page-title">
//         <h2 className="text-start">Referral Details for Servitor #{id}</h2>
//         <p className="srd-subtitle text-start">View and manage referral information</p>
//       </div>

//       {/* Stat Cards (row 1) */}
//       <Row className="g-3 mb-4">
//         <Col xl={4} md={6}>
//           <Card className="srd-stat-card srd-left-border srd-border-primary">
//             <div className="srd-stat-content">
//               <div className="srd-stat-title">Name</div>
//               <div className="srd-stat-value">{summary?.name || "—"}</div>
//             </div>
//             <div className="srd-stat-icon srd-icon-teal"><FiUser /></div>
//           </Card>
//         </Col>

//         <Col xl={4} md={6}>
//           <Card className="srd-stat-card srd-left-border srd-border-blue">
//             <div className="srd-stat-content">
//               <div className="srd-stat-title">Mobile</div>
//               <div className="srd-stat-value">{summary?.mobile || "—"}</div>
//             </div>
//             <div className="srd-stat-icon srd-icon-blue"><FiPhone /></div>
//           </Card>
//         </Col>

//         <Col xl={4} md={12}>
//           <Card className="srd-stat-card srd-left-border srd-border-violet">
//             <div className="srd-stat-content">
//               <div className="srd-stat-title">Referral Code</div>
//               <div className="srd-stat-value code">{summary?.referralCode || "—"}</div>
//             </div>
//             <div className="srd-stat-icon srd-icon-violet"><FiCode /></div>
//           </Card>
//         </Col>
//       </Row>

//       {/* Stat Cards (row 2) */}
//       <Row className="g-3 mb-4">
//         <Col xl={4} md={6}>
//           <Card className="srd-stat-card srd-left-border srd-border-orange">
//             <div className="srd-stat-content">
//               <div className="srd-stat-title">Invited</div>
//               <div className="srd-stat-value">{summary?.invitedCount ?? 0}</div>
//             </div>
//             <div className="srd-stat-icon srd-icon-orange"><FiUsers /></div>
//           </Card>
//         </Col>

//         <Col xl={4} md={6}>
//           <Card className="srd-stat-card srd-left-border srd-border-green">
//             <div className="srd-stat-content">
//               <div className="srd-stat-title">Qualified</div>
//               <div className="srd-stat-value">{summary?.qualifiedCount ?? 0}</div>
//             </div>
//             <div className="srd-stat-icon srd-icon-green"><FiCheckCircle /></div>
//           </Card>
//         </Col>

//         <Col xl={4} md={12}>
//           <Card className="srd-stat-card srd-total-earned">
//             <div className="srd-stat-content">
//               <div className="srd-stat-title light">Total Earned</div>
//               <div className="srd-total-amount">
//                 <FiDollarSign className="me-1" />
//                 {formatBDT(totalEarned)}
//               </div>
//             </div>
//             <div className="srd-stat-icon srd-icon-ghost"><FiDollarSign /></div>
//           </Card>
//         </Col>
//       </Row>

//       {/* Table Card */}
//       <Card className="servitorreferral-card srd-table-card">
//         <Card.Header className="srd-table-header">
//           <h5 className="mb-0 text-start">Invited Servitors</h5>
//         </Card.Header>
//         <Card.Body className="p-0">
//           <Table hover responsive className="servitorreferral-table mb-0">
//             <thead>
//               <tr>
//                 <th className="text-start">#</th>
//                 <th className="text-start">Invited Servitor</th>
//                 <th className="text-start">Servitor ID</th>
//                 <th className="text-start">Mobile</th>
//                 <th className="text-start">Bonus Amount</th>
//                 <th className="text-start">Feedback</th>
//                 <th className="text-start">Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {details.length > 0 ? (
//                 details.map((tx, i) => (
//                   <tr key={tx.Id || `${tx.refPeerServitorId}-${i}`} className="srd-row">
//                     <td>{i + 1}</td>
//                     <td>
//                       <div className="srd-invitee">
//                         <div className="srd-avatar">{initialsOf(tx?.peer?.fullName)}</div>
//                         <div className="srd-name">{tx?.peer?.fullName || "Unknown"}</div>
//                       </div>
//                     </td>
//                     <td className="srd-mono">{tx?.peer?.id ?? "—"}</td>
//                     <td className="srd-mono">{tx?.peer?.mobile ?? "—"}</td>
//                     <td>
//                       <Badge bg="success" className="srd-money-pill">
//                         {formatBDT(tx?.servitorBonus ?? 0)}
//                       </Badge>
//                     </td>
//                     <td className="srd-muted">{tx?.feedback || "—"}</td>
//                     <td className="srd-mono">{new Date(tx.transactionDate).toLocaleString()}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7" className="text-center py-4">No referral transactions found.</td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }








// ***** Upper code is okay, Updated with Auth protect (2-Dec-2025) ***** //
import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container, Card, Table, Button, Spinner, Alert, Row, Col, Badge
} from "react-bootstrap";
import {
  FiUser, FiPhone, FiCode, FiUsers, FiCheckCircle, FiDollarSign, FiArrowLeft
} from "react-icons/fi";
import { URL } from "../../../config";
import "./ServitorReferral.css";

export default function ServitorReferralDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [details, setDetails] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // helpers
  const formatBDT = (n) => `৳${Number(n || 0).toLocaleString()}`;
  const initialsOf = (fullName = "") =>
    fullName
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((s) => s[0]?.toUpperCase() || "")
      .join("") || "NA";

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      try {
        const adminToken = localStorage.getItem("adminToken");

        const { data } = await axios.get(
          `${URL}/admin/servitor-referral/${id}`,
          {
            headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
          }
        );
        setDetails(Array.isArray(data?.transactions) ? data.transactions : []);
        setSummary(data?.summary || null);
        setError("");
      } catch (err) {
        console.error("Error fetching details:", err);
        setError("Failed to load referral details.");
        setDetails([]);
        setSummary(null);
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [id]);

  const totalEarned = useMemo(
    () => summary?.totalEarned ?? 0,
    [summary]
  );

  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="border" />
        <p>Loading referral details...</p>
      </div>
    );
  }

  if (error)
    return (
      <Alert variant="danger" className="mx-3">
        {error}
      </Alert>
    );

  return (
    <Container fluid className="servitorreferral-container">
      {/* Topbar with Back */}
      <div className="srd-topbar">
        <div className="srd-topbar-left">
          <Button
            variant="link"
            className="srd-back-btn-top"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <FiArrowLeft className="me-2" />
            Back
          </Button>
        </div>
        <div className="srd-topbar-right">{/* space for future actions */}</div>
      </div>

      {/* Page Title */}
      <div className="srd-page-title">
        <h2 className="text-start">Referral Details for Servitor #{id}</h2>
        <p className="srd-subtitle text-start">
          View and manage referral information
        </p>
      </div>

      {/* Stat Cards (row 1) */}
      <Row className="g-3 mb-4">
        <Col xl={4} md={6}>
          <Card className="srd-stat-card srd-left-border srd-border-primary">
            <div className="srd-stat-content">
              <div className="srd-stat-title">Name</div>
              <div className="srd-stat-value">{summary?.name || "—"}</div>
            </div>
            <div className="srd-stat-icon srd-icon-teal">
              <FiUser />
            </div>
          </Card>
        </Col>

        <Col xl={4} md={6}>
          <Card className="srd-stat-card srd-left-border srd-border-blue">
            <div className="srd-stat-content">
              <div className="srd-stat-title">Mobile</div>
              <div className="srd-stat-value">{summary?.mobile || "—"}</div>
            </div>
            <div className="srd-stat-icon srd-icon-blue">
              <FiPhone />
            </div>
          </Card>
        </Col>

        <Col xl={4} md={12}>
          <Card className="srd-stat-card srd-left-border srd-border-violet">
            <div className="srd-stat-content">
              <div className="srd-stat-title">Referral Code</div>
              <div className="srd-stat-value code">
                {summary?.referralCode || "—"}
              </div>
            </div>
            <div className="srd-stat-icon srd-icon-violet">
              <FiCode />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Stat Cards (row 2) */}
      <Row className="g-3 mb-4">
        <Col xl={4} md={6}>
          <Card className="srd-stat-card srd-left-border srd-border-orange">
            <div className="srd-stat-content">
              <div className="srd-stat-title">Invited</div>
              <div className="srd-stat-value">
                {summary?.invitedCount ?? 0}
              </div>
            </div>
            <div className="srd-stat-icon srd-icon-orange">
              <FiUsers />
            </div>
          </Card>
        </Col>

        <Col xl={4} md={6}>
          <Card className="srd-stat-card srd-left-border srd-border-green">
            <div className="srd-stat-content">
              <div className="srd-stat-title">Qualified</div>
              <div className="srd-stat-value">
                {summary?.qualifiedCount ?? 0}
              </div>
            </div>
            <div className="srd-stat-icon srd-icon-green">
              <FiCheckCircle />
            </div>
          </Card>
        </Col>

        <Col xl={4} md={12}>
          <Card className="srd-stat-card srd-total-earned">
            <div className="srd-stat-content">
              <div className="srd-stat-title light">Total Earned</div>
              <div className="srd-total-amount">
                <FiDollarSign className="me-1" />
                {formatBDT(totalEarned)}
              </div>
            </div>
            <div className="srd-stat-icon srd-icon-ghost">
              <FiDollarSign />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Table Card */}
      <Card className="servitorreferral-card srd-table-card">
        <Card.Header className="srd-table-header">
          <h5 className="mb-0 text-start">Invited Servitors</h5>
        </Card.Header>
        <Card.Body className="p-0">
          <Table hover responsive className="servitorreferral-table mb-0">
            <thead>
              <tr>
                <th className="text-start">#</th>
                <th className="text-start">Invited Servitor</th>
                <th className="text-start">Servitor ID</th>
                <th className="text-start">Mobile</th>
                <th className="text-start">Bonus Amount</th>
                <th className="text-start">Feedback</th>
                <th className="text-start">Date</th>
              </tr>
            </thead>
            <tbody>
              {details.length > 0 ? (
                details.map((tx, i) => (
                  <tr
                    key={tx.Id || `${tx.refPeerServitorId}-${i}`}
                    className="srd-row"
                  >
                    <td>{i + 1}</td>
                    <td>
                      <div className="srd-invitee">
                        <div className="srd-avatar">
                          {initialsOf(tx?.peer?.fullName)}
                        </div>
                        <div className="srd-name">
                          {tx?.peer?.fullName || "Unknown"}
                        </div>
                      </div>
                    </td>
                    <td className="srd-mono">{tx?.peer?.id ?? "—"}</td>
                    <td className="srd-mono">{tx?.peer?.mobile ?? "—"}</td>
                    <td>
                      <Badge bg="success" className="srd-money-pill">
                        {formatBDT(tx?.servitorBonus ?? 0)}
                      </Badge>
                    </td>
                    <td className="srd-muted">
                      {tx?.feedback || "—"}
                    </td>
                    <td className="srd-mono">
                      {new Date(tx.transactionDate).toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    No referral transactions found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
}
